import { setting } from './_setting.js';
import { object } from './_obj.js';
import { load } from './_load.js';
import { chart } from './_chart.js';
import { comment } from './_comment.js';
import Cookies from 'js-cookie';
/*
Cookies
lastAccessTime: 最後にアクセスした時の聴取時間
showComplete: 今月の達成モーダルを表示したか
showCompleteLastMonth: 先月の達成モーダルを表示したか
*/
let week = ["日", "月", "火", "水", "木", "金", "土"];
let flickParam = {
	startX: 0,
	moveX: 0,
	current: 1,
	max: 1,
	area: null
}
const CookieExpire = 31;
export let listen = {
	url: "/jlc/listenplus/app/listening_result.json",
	data: {},
	isDebug: false,
	lastAccessTime: 0,
	isShowedComplete: false,
	isThisMonth: true,
	currentMonth: 0,//現在の月
	lastMonthData: "",
	getMyData: function(){
		let apiURL = listen.url;
		if(location.hostname.includes("kentaromi.tokyo") || location.hostname.includes("macbook-pro.local")){
			listen.isDebug = true;
		}else{
			apiURL = setting.weekly;
		}
		//Cookies.remove('showComplete');
		//console.log(apiURL);
		load.getJson(apiURL, {}).then( (res) => {
			listen.data = res.data.listening_data;
			listen.makeHTML();
		});
	},
	makeHTML: function(){
		//weekly
		let lastWeekTime;
		if(listen.data.thisweek_time){
			lastWeekTime = parseInt( listen.data.lastweek_total_time );
		}
		 
		let thisWeekTotal 	= 0;
		let weeklyHTML = "";
		let weeklyData;
		let thisMonthTotal = 0;
		
		
		weeklyData = listen.data.thisweek_time;
		if( !weeklyData ){
			thisWeekTotal 	= 0;
			lastWeekTime 	= 0;
			thisMonthTotal 	= 0;
			document.querySelector(".chart_currentmonth .monthly_time dl dt").innerHTML = "";
			let $lastMonth = document.querySelector(".link_lastMonth");
			if($lastMonth){
				document.querySelector(".link_lastMonth").innerHTML = "";
			}
			document.querySelector("body").classList.remove("disable");
		}else{
			for(let i = 0; i < weeklyData.length; i++){
				let d = weeklyData[i];
				let date = listen.getDate(d.date);
				let time = listen.calcTime(d.time);
				thisWeekTotal += d.time;
				weeklyHTML 	+= `<li>
									<div class="block_day">
										<div class="inr">
											<div class="ttl_date"><p>${date}</p></div>
											<div class="time_date">
												${time}
											</div>
										</div>
									</div>
								</li>`;
			}
			document.querySelector(".list_day ul").innerHTML = weeklyHTML;
			//今月の合計聴取時間
			thisMonthTotal = parseInt( listen.data.thismonth_total_time );
		}
		document.querySelector(".block_recently .total_time").innerHTML = listen.calcTime(thisWeekTotal);
		//今月の合計聴取時間
		let goalTime = 60*50;
		//thisMonthTotal =  parseInt( Cookies.get('lastAccessTime') ) + 3000;
		listen.addMonthTotal(thisMonthTotal);
		
		if(thisMonthTotal >= goalTime){
			let HTML = `<dl class="complete"><dt>今月のデジタルステッカー獲得!!</dt><dd>配布日は翌月上旬！</dd></dl>`
			document.querySelector(".block_totaling .content").innerHTML = HTML;
			listen.showComplete(flickParam.current);
		}else{
			let leftTime = goalTime - thisMonthTotal;
			let h = Math.floor(leftTime/60);
			let m = leftTime%60;
			let HTML = `<dl class="unreached">
							<dt>デジタルステッカー獲得まで</dt>
							<dd><span class="txt">あと</span><span class="time">${h}<span class="unit">h</span>${('0'+ m).slice(-2)}<span class="unit">m</span></span></dd>
						</dl>`;
			document.querySelector(".block_totaling .content").innerHTML = HTML;
		}
		let imgpath = "";
		if(thisWeekTotal === lastWeekTime){
			imgpath = "/jlc/listenplus/app/assets/images/common/icon_even.svg";
		}else if(thisWeekTotal > lastWeekTime){
			imgpath = "/jlc/listenplus/app/assets/images/common/icon_up.svg";
		}else if(thisWeekTotal < lastWeekTime){
			imgpath = "/jlc/listenplus/app/assets/images/common/icon_down.svg";
		}
		document.querySelector(".comparison img").setAttribute("src", imgpath);
		
		if( listen.data.counting_start){
			listen.getPeriod(parseInt(listen.data.counting_start));
		}else{
			let period = `<span class="start"</span> - <span class="end"></span>`;
			document.querySelector(".block_totaling dd").innerHTML = period;
		}
	},
	addMonthTotal: function(time){
		//今月
		let lastTime = parseInt( Cookies.get('lastAccessTime') );
		if(lastTime){
			if(time < lastTime){
				Cookies.remove('showComplete');
				Cookies.remove('showCompleteLastMonth');
			}
		}
		let timeHTML 	= getTotalTime(time);
		let dataCount 	= getDataCount(time)
		document.querySelector(".chart_currentmonth .pie_chart").setAttribute("data-count", dataCount);
		document.querySelector(".chart_currentmonth .monthly_time dd.time").innerHTML = timeHTML;
		Cookies.set('lastAccessTime', time, { expires: CookieExpire });
		comment.init(time);
		//先月のを取得
		if(listen.data.lastweek_total_time){
			listen.getLastMonthData();
			let $body = document.querySelector("body");
			if( $body.classList.contains("disable") ){
				$body.classList.remove("disable");
			}
		}
	},
	getDate: function(date){
		let day		= new Date(date);
		let thisday = `${day.getMonth()+1}/${day.getDate()} <span class="dow">${week[day.getDay()]}</span>`;
		return thisday;
	},
	calcTime: function(time){
		let h = Math.floor(time/60);
		let m = time%60;
		let t = `<p>${h}<span class="unit">h</span> ${('0'+ m).slice(-2)}<span class="unit">m</span></p>`;
		return t;
	},
	getPeriod: function(countingStart){
		let today 			= new Date();
		let currentYear 	= today.getFullYear();
		let currentMonth 	= today.getMonth() + 1;
		//countingStart = 12;
		//currentMonth = 1;
		if(currentMonth === 1 && countingStart === 12){
			currentYear -= 1;
		}
		let startDate 	= new Date(currentYear + "/" + countingStart + "/1");
		let endDate 	= new Date(startDate.getFullYear(), startDate.getMonth()+1, 0); 
		//console.log(startDate);
		listen.currentMonth = startDate;
		let period = `<span class="start">${startDate.getMonth() + 1}/${startDate.getDate()}　0:00</span> - <span class="end">${endDate.getMonth() + 1}/${endDate.getDate()}　23:59</span>`;
		document.querySelector(".block_totaling dd").innerHTML = period;
		let blocks = document.querySelectorAll(".monthly_time");
		blocks.forEach( ( $month ) => {
			//console.log(m)
			$month.querySelector("dt span").innerHTML = countingStart;
		});
	},
	showComplete: function(monthType){
		let $body = document.querySelector("body");
		let isShowed;
		if(monthType === 1){ //今月
			isShowed = Cookies.get('showComplete');
		}else{ //先月
			isShowed = Cookies.get('showCompleteLastMonth');
		}
		//document.querySelector(".my_status h2").innerHTML = isShowed;
		console.log(isShowed);
		if( !$body.classList.contains("show_complete") ){
			if(!isShowed || isShowed === 0 || isShowed === "0"){
				$body.classList.add("show_complete");
				listen.modalNav();
				if(monthType === 1){ //今月
					Cookies.set('showComplete', 1, { expires: CookieExpire });
				}else{ //先月
					Cookies.set('showCompleteLastMonth', 1, { expires: CookieExpire });
				}
			}
		}
	},
	modalNav: function(){
		let $closes = document.querySelectorAll("[data-close-complete]");
		$closes.forEach( ($close) => {
			$close.removeEventListener("click", closeModal, false);
			$close.addEventListener("click", closeModal, false);
		});
		
		function closeModal(){
			let $body = document.querySelector("body");
			if( $body.classList.contains("show_complete") ){
				$body.classList.remove("show_complete");
			}
		}
	},
	getLastMonthData: function(){
		let url = "/jlc/listenplus/app/result_history.json";
		if(!listen.isDebug){
			url = setting.history;
		}
		
		load.getJson(url, {}).then( (res) => {
			let data 			= res.data.listening_data.monthly_result;
			let currentDate 	= listen.currentMonth;
			let lm 				= new Date( currentDate.setMonth( currentDate.getMonth() - 1 ) );
			
			let y = lm.getFullYear();
			let m = lm.getMonth()+1;
			let lastMonth = `${y}-${('0'+ m).slice(-2)}`;
			let lastMonthData = "";
			
			
			for(let i = 0; i < data.length; i++){
				let d = data[i];
				if(lastMonth === d.date){
					lastMonthData = d;
				}
			}
			listen.lastMonthData = lastMonthData;
			if(lastMonthData != ""){
				listen.addLastMonthData(lastMonthData);
			}else{
				document.querySelector(".link_lastMonth").innerHTML = "";
			}
			
			//チャートをセット
			chart.pie();
		});
	},
	addLastMonthData: function(data){
		console.log(data);
		let $lastMonth = document.querySelector(".chart_lastmonth");
		
		let dataCount = getDataCount(data.time);
		$lastMonth.querySelector(".pie_chart").setAttribute("data-count", dataCount);
		$lastMonth.querySelector(".monthly_time dl dt span").innerHTML 	= data.date.split("-")[1].replace("0", "");
		
		let timeHTML = getTotalTime(data.time);
		$lastMonth.querySelector(".monthly_time dl dd.time").innerHTML = timeHTML;
		listen.monthNav();
	},
	monthNav: function(){
		let $btnLastMonth = document.querySelector("[data-last-month]");
		$btnLastMonth.removeEventListener("click", listen.decChart, false);
		$btnLastMonth.addEventListener("click", listen.decChart, false);
		
		let $btnCurrrentMonth = document.querySelector("[data-current-month]");
		$btnCurrrentMonth.removeEventListener("click", listen.incChart, false);
		$btnCurrrentMonth.addEventListener("click", listen.incChart, false);
		
		let flickArea = document.querySelector(".wrap_chart");
		flickParam.area = flickArea.querySelector(".charts");
		
		if( document.documentElement.classList.contains("mobile") ){
			flickArea.removeEventListener("touchstart", listen.touchstart.bind(this), false);
			flickArea.addEventListener("touchstart", listen.touchstart.bind(this), false);
			
			flickArea.removeEventListener("touchmove", listen.touchmove.bind(this), false);
			flickArea.addEventListener("touchmove", listen.touchmove.bind(this), false);
			
			flickArea.removeEventListener("touchend", listen.touchend.bind(this), false);
			flickArea.addEventListener("touchend", listen.touchend.bind(this), false);
		}
	},
	touchstart: function(e){
		flickParam.startX = 0;
		flickParam.startX = e.touches[0].pageX;
		
		if( !flickParam.area.classList.contains("touching") ){
			flickParam.area.classList.add("touching");
		}
	},
	touchmove: function(e){
		let current 	= e.touches[0].pageX;
		let diff 		= current - flickParam.startX;
		let posX 		= (diff/document.querySelector(".wrap_chart").clientWidth)*100 + flickParam.current*-100;
		//console.log(posX);
		if(flickParam.current === 1 && diff > 0){
			flickParam.area.style.transform = `translate3d(${posX}%, 0, 0)`;
		}else if(flickParam.current === 0 && diff < 0){
			flickParam.area.style.transform = `translate3d(${posX}%, 0, 0)`;
		}
		flickParam.moveX = diff;
	},
	touchend: function(){
		//console.log("touchend", flickParam.moveX);
		if(flickParam.moveX < -80){
			flickParam.current++;
			if(flickParam.current > flickParam.max){
				flickParam.current = flickParam.max;
			}
			listen.moveChart();
		}else if(flickParam.moveX > 80){
			flickParam.current--;
			if(flickParam.current < 0){
				flickParam.current = 0;
			}
			listen.moveChart();
		}else{
			flickParam.area.style.transform = `translate3d(${flickParam.current*-100}%, 0, 0)`;
		}
		if( flickParam.area.classList.contains("touching") ){
			flickParam.area.classList.remove("touching");
		}
		flickParam.startX = 0;
		flickParam.moveX = 0;
	},
	moveChart: function(){
		let posX = -100 * flickParam.current;
		let $chart = document.querySelector(".block_chart");
		$chart.classList.remove("current");
		$chart.classList.remove("last");
		flickParam.area.style.transform = `translate3d(${posX}%, 0, 0)`;
		if(flickParam.current === 0){
			chart.runPie(0);
			$chart.classList.add("last");
			listen.checkLastMonthComplete();
		}else{
			$chart.classList.add("current");
		}
	},
	incChart: function(){
		flickParam.current++;
		listen.moveChart();
	},
	decChart: function(){
		flickParam.current--;
		listen.moveChart();
	},
	checkLastMonthComplete: function(){
		let totalTime = listen.lastMonthData.time;
		//totalTime = 3000;
		if(totalTime >= 60*50){
			//console.log("complete");
			document.querySelector(".chart_lastmonth img").setAttribute("src", "https://www.j-wave.co.jp/jlc/listenplus/app/images/jme/50h.png");
			listen.showComplete(flickParam.current);
		}else{
			//console.log("not complete");
		}
	},
	getLastMonth: function(){
		listen.isThisMonth = false;
		document.querySelector(".block_chart").classList.add("disable");
		setTimeout(function(){
			//chartをリセットして先月のデータをセット
			
			//データをセット後、チャートを表示
			listen.showChart();
		}, 600);
	},
	showChart: function(){
		let $chart = document.querySelector(".block_chart");
		$chart.classList.add("r");
		$chart.classList.remove("disable");
		setTimeout(function(){
			setTimeout(function(){
				$chart.classList.remove("r");
			}, 50);
		}, 200);
	},
}

var getTotalTime = function(time){
	let h = Math.floor(time/60);
	let m = time%60;
	let HTML = `${h}<span>h</span>${('0'+ m).slice(-2)}<span>m</span>`;
	return HTML;
}
var getDataCount = function(time){
	let dataCount = time/60;
	let countLimit = 100;
	dataCount = dataCount > countLimit ? countLimit : dataCount;
	return dataCount;
}